var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-3"},[_c('todos-lotes-itens',{attrs:{"casasDecimais":_vm.quantidadeCasasDecimais,"validarLancesPor":_vm.validarLancesPor,"criterioJulgamento":_vm.criterioJulgamento},model:{value:(_vm.resultadoTodosLotesEItens),callback:function ($$v) {_vm.resultadoTodosLotesEItens=$$v},expression:"resultadoTodosLotesEItens"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }